import dataRangers from '@datarangers/sdk-javascript';
import { APP_VERSION, SITE } from '@/app/constants';
import { getUsingLanguage } from '../client/get-using-language';
import { hysdk } from '../hy-sdk';

export let dataFinderGlobalProperties = {};

export const initDataFinder = () => {
  // 初始化数据埋点
  dataRangers.init({
    app_id: Number(process.env.NEXT_PUBLIC_DATAFINDER_APP_ID),
    channel: SITE === 'china' ? 'cn' : 'sg',
    channel_domain: process.env.NEXT_PUBLIC_DATAFINDER_CHANNEL_DOMAIN,
    disable_sdk_monitor: false,
    log: true,
  });

  // 注册公共属性
  dataFinderGlobalProperties = {
    app_version: `${hysdk.sniff.appVersion}-${hysdk.sniff.codeVersion}`,
    language: getUsingLanguage() as string,
    platform_type: 'web',
    web_version: APP_VERSION,
    website: SITE,
  };
  // 配置公共属性
  dataRangers.config(dataFinderGlobalProperties);

  dataRangers.start();
};

export const reportEvent = (eventName: string, properties?: Record<string, string | boolean | number>) => {
  dataRangers.event(eventName, {
    ...dataFinderGlobalProperties,
    ...properties,
  });
};

export const setRegisterPage = (profile: {
  uid?: string;
  language?: string;
  is_member?: boolean;
  member_type?: string;
}) => {
  dataFinderGlobalProperties = {
    ...dataFinderGlobalProperties,
    ...profile,
  };

  dataRangers.config(dataFinderGlobalProperties);
  dataRangers.send();
};

export const dataRangersSignUp = (user_unique_id: string) => {
  if (!user_unique_id) return;
  dataRangers.config({
    user_unique_id,
  });
  dataRangers.send();
};

export const dataRangersSignOut = () => {
  dataRangers.config({
    user_unique_id: '',
  });
  dataRangers.send();
};
